/* Datum & Ink — framing rotation for the catalogue cards.

   Hovering a card cycles that plate through its other presentations, so the
   grid answers "what does this look like framed differently" without a click.

   Horizon renders exactly one <img> per card, so there is nothing in the DOM to
   cross-fade between. The presentations come from /products/<handle>.js,
   fetched once per handle on first hover and cached for the rest of the page.

   Deliberately mirrors assets/di-dot-hero-feature.js:

   - Hovering advances one presentation IMMEDIATELY, then the interval takes
     over. Waiting a full beat before anything moves reads as broken, and it
     means the behaviour can be verified without depending on a timer.
   - The active index lives on the element as data-di-active, so state is
     inspectable and survives anything that re-runs this script.

   Two things that are easy to get wrong here:

   - srcset has to be cleared before src will win. Horizon ships a responsive
     srcset on the card image and the browser keeps honouring it otherwise, so
     setting src alone changes nothing visible.
   - The resting src/srcset are stashed before the first advance and restored on
     leave, so a card that is never hovered is never touched at all. */
(function () {
  var ROTATE_MS = 1100;
  var WIDTH = 832;                  // the width Horizon renders these cards at

  var ready = {};                   // handle -> [url]
  var waiting = {};                 // handle -> [callback]

  var touch = window.matchMedia('(hover: none)').matches;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function image(card) {
    return card.querySelector('img.product-media__image') || card.querySelector('img');
  }

  function handleOf(card) {
    var link = card.querySelector('a.product-card__link');
    var href = (link && link.getAttribute('href')) || '';
    var found = href.match(/\/products\/([^\/?#]+)/);
    return found ? found[1] : null;
  }

  function sized(src) {
    if (!src) return src;
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + WIDTH;
  }

  function settle(handle, urls) {
    ready[handle] = urls;
    (waiting[handle] || []).forEach(function (done) { done(urls); });
    delete waiting[handle];
  }

  function presentations(handle, done) {
    if (ready[handle]) return done(ready[handle]);
    if (waiting[handle]) return waiting[handle].push(done);
    waiting[handle] = [done];

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        settle(handle, ((product && product.images) || []).map(sized));
      })
      .catch(function () { settle(handle, []); });
  }

  function show(card, n) {
    var img = image(card);
    var urls = card.__diUrls;
    if (!img || !urls || !urls.length) return;
    var idx = ((n % urls.length) + urls.length) % urls.length;
    card.dataset.diActive = idx;
    img.setAttribute('srcset', '');   // otherwise the responsive set still wins
    img.setAttribute('src', urls[idx]);
  }

  function activeIndex(card) {
    return parseInt(card.dataset.diActive, 10) || 0;
  }

  function begin(card) {
    if (card.__diTimer) return;
    var handle = handleOf(card);
    if (!handle) return;

    presentations(handle, function (urls) {
      // One image is not a rotation. Leave those cards completely alone.
      if (urls.length < 2 || card.__diTimer) return;
      var img = image(card);
      if (!img) return;

      if (!card.__diRest) {
        card.__diRest = {
          src: img.getAttribute('src'),
          srcset: img.getAttribute('srcset') || ''
        };
      }
      card.__diUrls = urls;
      urls.forEach(function (url) { new Image().src = url; });  // no first-advance flicker

      show(card, activeIndex(card) + 1);
      if (still) return;              // a single step is enough when motion is reduced

      card.__diTimer = setInterval(function () {
        show(card, activeIndex(card) + 1);
      }, ROTATE_MS);
    });
  }

  function end(card) {
    clearInterval(card.__diTimer);
    card.__diTimer = 0;

    var img = image(card);
    var rest = card.__diRest;
    if (img && rest) {
      img.setAttribute('src', rest.src);
      if (rest.srcset) img.setAttribute('srcset', rest.srcset);
      else img.removeAttribute('srcset');
    }
    delete card.dataset.diActive;
  }

  // Delegated, so this keeps working through any grid re-render or pagination.
  function bind() {
    if (document.__diCardRotateBound) return;
    document.__diCardRotateBound = true;

    document.addEventListener('pointerover', function (e) {
      if (touch || !e.target.closest) return;
      var card = e.target.closest('product-card');
      if (card && !card.contains(e.relatedTarget)) begin(card);
    });

    document.addEventListener('pointerout', function (e) {
      if (touch || !e.target.closest) return;
      var card = e.target.closest('product-card');
      if (card && !card.contains(e.relatedTarget)) end(card);
    });

    document.addEventListener('focusin', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('product-card');
      if (card) begin(card);
    });

    document.addEventListener('focusout', function (e) {
      if (!e.target.closest) return;
      var card = e.target.closest('product-card');
      if (card && !card.contains(e.relatedTarget)) end(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
